import firedux from '../firedux'
import {dispatch} from '../store'

import {
  MESSAGES_ENDPOINT
} from '../../config/constants'

import updateMessageAttr from '../actions/update_message_attr'

const onMessageUpdate = (containerId, messageId, snapshot) => {
  dispatch(updateMessageAttr(containerId, messageId, snapshot.key(), snapshot.val()))
}

export const watchMessage = (containerId, messageId) => {
  if (!containerId || !messageId) return

  const ref = firedux.ref.child(MESSAGES_ENDPOINT).child(containerId).child(messageId)

  ref.on('child_changed', onMessageUpdate.bind(null, containerId, messageId))
}

export const unwatchMessage = (containerId, messageId) => {
  if (!containerId || !messageId) return

  const ref = firedux.ref.child(MESSAGES_ENDPOINT).child(containerId).child(messageId)

  ref.off('child_changed')
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/message.js
 **/